/**
 * I3 ฮึกเหิมประลอง: a duel win lifts training for a while. Listens to the bout results (duelMatch / pvpDuel emit
 * `pvpDuel` phase 'result'); only the player's wins count, each opponent once, the first 5 wins of a real day
 * (the day number comes from dayReset.ts via `cultivation.boostDay`). Sets the ledger's `duel` source.
 */
import { dayRoll } from './dayRoll';
import type { SystemHost, WorldSystem } from './types';
import type { WorldEvent } from '../world';

export const DUEL_WIN_BOOST = { bonus: 0.2, seconds: 1800, maxWins: 5 } as const;

export class DuelWinBoostSystem implements WorldSystem {
  readonly name = 'duelWinBoost';
  day = Number.NaN;
  private foes = new Set<string>();
  constructor(private readonly h: SystemHost) {}

  realDay(day: number): void {
    dayRoll(this, day, () => this.foes.clear());
  }

  /** Wins counted on the current training day (0 when the day has turned and no win has rolled it yet). */
  winsToday(): number {
    return this.h.world.sys.cultivation.boostDay === this.day ? this.foes.size : 0;
  }

  /** Wins counted today. */
  get wins(): number {
    return this.foes.size;
  }

  observe(e: WorldEvent): void {
    if (e.type !== 'pvpDuel' || e.phase !== 'result') return;
    const w = this.h.world;
    if (w.auto.on) return; // J3: auto play never feeds the duel-win buff
    const me = w.player.id;
    if (e.winner !== me || (e.a !== me && e.b !== me)) return;
    const cult = w.sys.cultivation;
    dayRoll(this, cult.boostDay, () => this.foes.clear());
    const foe = e.a === me ? e.names[1] : e.names[0];
    if (this.foes.has(foe) || this.foes.size >= DUEL_WIN_BOOST.maxWins) return;
    this.foes.add(foe);
    cult.boost.set('duel', DUEL_WIN_BOOST.bonus, DUEL_WIN_BOOST.seconds);
  }
}
